var v1="<div gnp-basic-analysis=\"\" basic-analysis-data=\"baeCtrl.basicAnalysisData\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-event/basic-analysis/basic-analysis.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/analysis-event/basic-analysis/basic-analysis.jade
// module id = 520
// module chunks = 0